import React, { useEffect, useState } from "react";
import TournamentForm from "Components/Tournament/TournamentForm";
import { useParams } from "react-router-dom";
import { fetchTournamentById } from "services/tournamentService";
import * as Sentry from "@sentry/react";

const TournamentFormPage = () => {
  const { locationId, tournamentId } = useParams();
  const [existingTournament, setExistingTournament] = useState(null);
  const [loading, setLoading] = useState(Boolean(tournamentId));

  useEffect(() => {
    const fetchTournament = async () => {
      if (tournamentId) {
        try {
          const data = await fetchTournamentById(tournamentId);
          setExistingTournament({ id: tournamentId, ...data });
        } catch (error) {
          Sentry.captureException(error);
          console.error("Failed to load tournament:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchTournament();
  }, [tournamentId]);

  const handleSuccess = () => {
    const redirectId = locationId || existingTournament?.locationId || "default";
    window.location.href = `/locations/${redirectId}`;
  };

  if (loading) return <div className="text-white text-center pt-20">Chargement...</div>;

  return (
    <div className="p-6 min-h-screen w-full bg-gray-700 pt-20">
      <TournamentForm
        existingTournament={existingTournament}
        locationId={locationId || existingTournament?.locationId}
        onSuccess={handleSuccess}
      />
    </div>
  );
};

export default TournamentFormPage;
